<template>
  <div class="page">
    <slot />
  </div>
</template>

<script>
import matomoPageTracker from 'beisheim/mixins/matomo-page-tracker'
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  mixins: [ editable, matomoPageTracker ],
  head () {
    const meta = []

    const title = this.resource.columns.meta_title || this.resource.columns.meta_og_title || this.resource.columns.title
    const description = this.resource.columns.meta_description || this.resource.columns.description

    if (description) {
      meta.push(
        { hid: 'description', name: 'description', content: description },
        { hid: 'og-description', name: 'og:description', content: description }
      )
    }
    if (this.resource.columns.meta_keywords) {
      meta.push(
        { hid: 'keywords', name: 'keywords', content: this.resource.columns.meta_keywords }
      )
    }
    if (this.image) {
      meta.push(
        { hid: 'og-image', name: 'og:image', content: this.image }
      )
    }
    return {
      title,
      meta: [
        { hid: 'og-title', name: 'og:title', content: title },
        ...meta
      ]
    }
  }
}
</script>
